// extracted by mini-css-extract-plugin
module.exports = {"link":"TxLink_link__uN8bx","active":"TxLink_active__2iIjK"};